<template>
  <div class="container h-full w-full">
    <div class="spinner border" />
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.container {
  margin: 20px auto;
}
.spinner {
  margin: calc(50% - 25px) auto;
  width: 50px;
  height: 50px;
  box-sizing: border-box;
  border: 3px solid rgba(118, 154, 255, 0.3);
  border-top-color: #4373ff;
  border-radius: 100%;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
